/**
 * Input Group Component
 * Responsible for showing input level errors specific to a particular field
 *
 */
import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, Inject, Input } from '@angular/core';
import { InteractivityService } from '../../../services/interactivity-service';

export type LabelPosition = 'left' | 'top'

@Component({
  selector: 'td-wb-input-group',
  templateUrl: 'input-group.component.html',
  styleUrls: ['input-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputGroupComponent {
  @Input() labelPosition: LabelPosition = 'top';
  @HostBinding('class.td-wb-input-group--label-top')
  get isLabelPositionTop(): boolean {
    return this.labelPosition === 'top';
  }

  constructor(@Inject(ElementRef) private elementRef: ElementRef,
              @Inject(InteractivityService) private interactivityService: InteractivityService) {
  }

  focusInput(): void {
    const elementRef = this.interactivityService.getFirstTabbableElement(this.elementRef.nativeElement);
    if (elementRef !== undefined) {
      elementRef.focus();
    }
  }
}
